/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import DeleteModal from './DeleteModal/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2IconEditFilled from 'DesignSystem/Svgs/Tysiav2IconEditFilled/index'
import Tysiav2Subtract from 'DesignSystem/Svgs/Tysiav2Subtract/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Tag({
  children,
  viewPath = "/DesignSystem/AutomationTask/Tags/Content/SearchResult/Content/Tag"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let tagIdValueData = fromData.useDataValue({ viewPath,
context: 'tag',
path: 'id',
})
let eventActionTagsValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'tags',
})
let aggregateData = fromHelpers.isTagSelected(tagIdValueData, eventActionTagsValueData)
let onChange = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let tagNameValueData = fromData.useDataValue({ viewPath,
context: 'tag',
path: 'name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick1 = fromHelpers.useOnClickEdit({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Tag.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-mwk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="tag.id"
 data="event_action.tags"
 aggregate="helpers.js isTagSelected"
 value={aggregateData}
 marginRight={6}
 onChange={onChange}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 height={18}
 width={18}
/>
)}
</TysiaCheckbox>
<button
  data-testid="Tag.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor={dtColorsNeutral900}
 data="tag.name"
 text={tagNameValueData}
/>
</button>
<div
  data-testid="Tag.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-2-mwk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 paddingLeft={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
 onClick={onClick1}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2IconEditFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2IconEditFilled`}
 width={12}
 height={12}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 paddingLeft={dtSpaceXxs}
 paddingRight={dtSpaceXxs}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'DeleteModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'DeleteModal/Content'))}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2Subtract
{...childProps}
  viewPath={`${viewPath}/Tysiav2Subtract`}
 width={12}
 height={12}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
</div>
<DeleteModal
  viewPath={`${viewPath}/DeleteModal`}
/>
{children}
</React.Fragment>)
}